export function section14() {
    const rtSocialSwiper = new Swiper(".rt-social-swiper", {
        slidesPerView: 4,
        centeredSlides: true,
        grabCursor: true,
        autoplay: true,
        autoplaySpeed: 3500,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    })

}
